const fr = {
  nav: {
    home: "Accueil",
    browse: "D\u00e9couvrir les mariages",
    browseWeddings: "D\u00e9couvrir les mariages",
    dashboard: "Tableau de bord",
    messages: "Messages",
    profile: "Profil",
    login: "Connexion",
    register: "S'inscrire",
    logout: "D\u00e9connexion",
    admin: "Admin",
  },
  landing: {
    hero: {
      badge: "La plateforme #1 d'exp\u00e9riences de mariage",
      title: "Vivez des mariages inoubliables dans le monde entier",
      subtitle: "WEDVAYA connecte les couples avec des voyageurs \u00e0 la recherche d'exp\u00e9riences culturelles authentiques. Faites partie d'un moment sp\u00e9cial \u2013 en tant qu'h\u00f4te ou invit\u00e9.",
      cta_host: "Commencer en tant qu'h\u00f4te",
      cta_guest: "D\u00e9couvrir les mariages",
    },
    trust: {
      freeRegistration: "Inscription gratuite",
      securePayment: "Paiement s\u00e9curis\u00e9",
      gdprCompliant: "Conforme au RGPD",
    },
    stats: {
      weddings: "Mariages",
      worldwide: "dans le monde",
      guests: "Invit\u00e9s",
      matched: "mis en relation",
      countries: "Pays",
      represented: "repr\u00e9sent\u00e9s",
      rating: "\u00c9valuation",
      average: "moyenne",
    },
    features: {
      title: "Pourquoi WEDVAYA ?",
      subtitle: "Nous rendons le partage d'exp\u00e9riences de mariage inoubliables facile et s\u00fbr.",
      secure: {
        title: "Paiements s\u00e9curis\u00e9s",
        desc: "Toutes les transactions sont prot\u00e9g\u00e9es par Stripe. Votre argent est en s\u00e9curit\u00e9 jusqu'\u00e0 l'\u00e9v\u00e9nement.",
      },
      verified: {
        title: "Profils v\u00e9rifi\u00e9s",
        desc: "V\u00e9rification d'identit\u00e9 optionnelle pour plus de confiance entre h\u00f4tes et invit\u00e9s.",
      },
      global: {
        title: "\u00c9v\u00e9nements mondiaux",
        desc: "Des mariages romantiques en Toscane aux c\u00e9l\u00e9brations traditionnelles en Inde.",
      },
      contact: {
        title: "Contact direct",
        desc: "Apr\u00e8s la r\u00e9servation, communiquez directement avec votre h\u00f4te.",
      },
      gdpr: {
        title: "Conforme au RGPD",
        desc: "Vos donn\u00e9es sont prot\u00e9g\u00e9es. Nous respectons strictement les r\u00e8gles europ\u00e9ennes de protection des donn\u00e9es.",
      },
      instant: {
        title: "R\u00e9servation instantan\u00e9e",
        desc: "Processus de candidature rapide. Vous recevrez une r\u00e9ponse sous 48 heures.",
      },
    },
    howItWorks: {
      title: "Comment \u00e7a marche",
      subtitle: "Quelques \u00e9tapes pour votre exp\u00e9rience inoubliable",
      step1: {
        title: "Trouver un mariage",
        desc: "Parcourez notre s\u00e9lection de mariages uniques dans le monde entier.",
      },
      step2: {
        title: "Envoyer une candidature",
        desc: "Pr\u00e9sentez-vous au couple et expliquez pourquoi vous souhaitez participer.",
      },
      step3: {
        title: "Confirmation & Paiement",
        desc: "Apr\u00e8s approbation, payez en ligne en toute s\u00e9curit\u00e9. Votre place est alors r\u00e9serv\u00e9e.",
      },
      step4: {
        title: "C\u00e9l\u00e9brer",
        desc: "Vivez un mariage authentique et cr\u00e9ez des souvenirs pour la vie.",
      },
    },
    howItWorksHost: {
      step1: {
        title: "Publier votre mariage",
        desc: "Cr\u00e9ez un profil pour votre mariage avec tous les d\u00e9tails importants.",
      },
      step2: {
        title: "Examiner les candidatures",
        desc: "Consultez les profils des invit\u00e9s int\u00e9ress\u00e9s.",
      },
      step3: {
        title: "\u00catre pay\u00e9",
        desc: "Apr\u00e8s l'\u00e9v\u00e9nement, vous recevez automatiquement 85% des revenus.",
      },
      step4: {
        title: "C\u00e9l\u00e9brer ensemble",
        desc: "Partagez votre jour sp\u00e9cial avec des personnes du monde entier.",
      },
    },
    tabs: {
      forGuests: "Pour les invit\u00e9s",
      forHosts: "Pour les h\u00f4tes",
    },
    testimonials: {
      title: "Ce que dit notre communaut\u00e9",
      subtitle: "De vraies exp\u00e9riences de vraies personnes",
    },
    featured: {
      title: "Mariages en vedette",
      subtitle: "D\u00e9couvrez des c\u00e9l\u00e9brations uniques dans le monde entier",
      viewAll: "Tout voir",
      perPerson: "par personne",
    },
    cta: {
      title: "Pr\u00eat pour votre exp\u00e9rience inoubliable ?",
      subtitle: "Rejoignez la communaut\u00e9 WEDVAYA",
      description: "Que vous souhaitiez partager votre mariage avec le monde ou vivre une exp\u00e9rience de voyage unique \u2013 WEDVAYA le rend possible.",
      button: "S'inscrire gratuitement",
      becomeHost: "Devenir h\u00f4te maintenant",
      learnMore: "En savoir plus",
    },
    press: {
      title: "Vu dans",
    },
  },
  auth: {
    login: {
      title: "Bon retour",
      email: "E-mail",
      password: "Mot de passe",
      button: "Connexion",
      noAccount: "Pas encore de compte ?",
      register: "Inscrivez-vous",
      forgotPassword: "Mot de passe oubli\u00e9 ?",
    },
    register: {
      title: "Cr\u00e9er un compte",
      name: "Nom complet",
      email: "E-mail",
      password: "Mot de passe",
      role: "Je veux...",
      roleHost: "Organiser un mariage",
      roleGuest: "Assister \u00e0 des mariages",
      terms: "J'accepte les conditions et la politique de confidentialit\u00e9",
      button: "S'inscrire",
      hasAccount: "D\u00e9j\u00e0 inscrit ?",
      login: "Connectez-vous",
    },
    forgotPassword: {
      title: "Mot de passe oubli\u00e9 ?",
      description: "Entrez votre e-mail et nous vous enverrons un lien de r\u00e9initialisation",
      submit: "Envoyer le lien",
      sent: "V\u00e9rifiez votre e-mail",
      sentDescription: "Si un compte existe avec cet e-mail, vous recevrez un lien de r\u00e9initialisation.",
      backToLogin: "Retour \u00e0 la connexion",
    },
    resetPassword: {
      title: "R\u00e9initialiser le mot de passe",
      description: "Entrez votre nouveau mot de passe ci-dessous",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      submit: "R\u00e9initialiser le mot de passe",
      success: "Mot de passe r\u00e9initialis\u00e9 !",
      successDesc: "Votre mot de passe a \u00e9t\u00e9 r\u00e9initialis\u00e9 avec succ\u00e8s. Vous pouvez maintenant vous connecter.",
      goToLogin: "Aller \u00e0 la connexion",
      mismatch: "Les mots de passe ne correspondent pas",
      tooShort: "Le mot de passe doit contenir au moins 6 caract\u00e8res",
    },
    verification: {
      verifying: "V\u00e9rification de votre e-mail...",
      pleaseWait: "Veuillez patienter",
      successTitle: "E-mail v\u00e9rifi\u00e9 !",
      success: "Votre e-mail a \u00e9t\u00e9 v\u00e9rifi\u00e9 avec succ\u00e8s !",
      errorTitle: "\u00c9chec de la v\u00e9rification",
      noToken: "Aucun jeton de v\u00e9rification fourni",
      goToLogin: "Aller \u00e0 la connexion",
      tryAgain: "S'inscrire \u00e0 nouveau",
    },
  },
  dashboard: {
    host: {
      title: "Tableau de bord h\u00f4te",
      myWeddings: "Mes mariages",
      applications: "Candidatures",
      earnings: "Revenus",
      messages: "Messages",
      createWedding: "Cr\u00e9er un mariage",
      noWeddings: "Aucun mariage cr\u00e9\u00e9",
    },
    guest: {
      title: "Tableau de bord invit\u00e9",
      myApplications: "Mes candidatures",
      browseWeddings: "Parcourir les mariages",
      messages: "Messages",
      profile: "Mon profil",
    },
  },
  wedding: {
    search: {
      title: "Trouver des mariages",
      location: "Lieu",
      date: "Date",
      price: "Prix",
      search: "Rechercher",
      reset: "R\u00e9initialiser",
      noResults: "Aucun mariage trouv\u00e9",
    },
    card: {
      slots: "places disponibles",
      perGuest: "par invit\u00e9",
      apply: "Postuler",
      viewDetails: "Voir les d\u00e9tails",
    },
    detail: {
      about: "\u00c0 propos de ce mariage",
      host: "H\u00f4te",
      location: "Lieu",
      date: "Date",
      dresscode: "Code vestimentaire",
      price: "Prix par invit\u00e9",
      slots: "Places disponibles",
      apply: "Postuler maintenant",
      alreadyApplied: "D\u00e9j\u00e0 postul\u00e9",
    },
    create: {
      title: "Cr\u00e9er un nouveau mariage",
      titleField: "Titre",
      description: "Description",
      location: "Lieu",
      country: "Pays",
      date: "Date",
      dresscode: "Code vestimentaire",
      price: "Prix par invit\u00e9",
      slots: "Nombre d'invit\u00e9s",
      currency: "Devise",
      submit: "Cr\u00e9er le mariage",
    },
  },
  application: {
    status: {
      pending: "En attente",
      approved: "Approuv\u00e9",
      rejected: "Rejet\u00e9",
    },
    payment: {
      pending: "Paiement en attente",
      paid: "Pay\u00e9",
      pay: "Payer maintenant",
    },
    approve: "Approuver",
    reject: "Rejeter",
  },
  review: {
    title: "\u00c9crire un avis",
    description: "Partagez votre exp\u00e9rience",
    ratingLabel: "Comment noteriez-vous votre exp\u00e9rience ?",
    rating1: "Mauvais",
    rating2: "Passable",
    rating3: "Bon",
    rating4: "Tr\u00e8s bien",
    rating5: "Excellent",
    commentLabel: "Votre avis",
    optional: "optionnel",
    commentPlaceholder: "Dites aux autres ce que vous ont fait vivre...",
    for: "Avis pour",
    submit: "Envoyer l'avis",
    success: "Avis envoy\u00e9 avec succ\u00e8s !",
    error: "\u00c9chec de l'envoi de l'avis",
    selectRating: "Veuillez s\u00e9lectionner une notation",
    noReviews: "Pas d'avis encore",
    received: "Avis re\u00e7us",
    averageRating: "Moyenne des notes",
    writeReview: "\u00c9crire un avis",
    reviewed: "\u00c9valu\u00e9",
    completedWedding: "Ce mariage est termin\u00e9. Vous pouvez maintenant \u00e9crire un avis.",
  },
  messages: {
    title: "Messages",
    noMessages: "Aucun message",
    placeholder: "\u00c9crire un message...",
    send: "Envoyer",
  },
  admin: {
    title: "Tableau de bord Admin",
    stats: {
      users: "Utilisateurs",
      hosts: "H\u00f4tes",
      guests: "Invit\u00e9s",
      weddings: "Mariages",
      activeWeddings: "Mariages actifs",
      applications: "Candidatures",
      revenue: "Revenu total",
      platformEarnings: "Gains de la plateforme",
    },
    tabs: {
      overview: "Aper\u00e7u",
      users: "Utilisateurs",
      weddings: "Mariages",
      transactions: "Transactions",
    },
    actions: {
      ban: "Bannir",
      unban: "D\u00e9bannir",
      feature: "Mettre en avant",
      unfeature: "Retirer de la une",
    },
  },
  common: {
    loading: "Chargement...",
    error: "Une erreur s'est produite",
    success: "Succ\u00e8s",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    back: "Retour",
    next: "Suivant",
    language: "Langue",
    currency: "Devise",
  },
  footer: {
    about: "\u00c0 propos",
    privacy: "Confidentialit\u00e9",
    terms: "Conditions",
    contact: "Contact",
    description: "La plateforme mondiale pour des exp\u00e9riences de mariage inoubliables.",
    copyright: "\u00a9 2024 WEDVAYA. Tous droits r\u00e9serv\u00e9s.",
  },
  notifications: {
    title: "Notifications",
    empty: "Pas encore de notifications",
    markAllRead: "Tout marquer comme lu",
  },
  chat: {
    conversations: "Conversations",
    search: "Rechercher des conversations...",
    noConversations: "Pas encore de conversations",
    selectConversation: "S\u00e9lectionnez une conversation",
    selectConversationDesc: "Choisissez une conversation dans la liste pour commencer \u00e0 discuter",
    online: "En ligne",
    offline: "Hors ligne",
    connecting: "Connexion...",
    noMessages: "Pas encore de messages",
    startConversation: "D\u00e9marrez la conversation !",
    placeholder: "Tapez un message...",
    you: "Vous",
  },
  cookies: {
    title: "Nous utilisons des cookies",
    description: "Nous utilisons des cookies pour am\u00e9liorer votre exp\u00e9rience, analyser le trafic et \u00e0 des fins marketing.",
    acceptAll: "Tout accepter",
    rejectAll: "Tout refuser",
    customize: "Personnaliser",
    settingsTitle: "Param\u00e8tres des cookies",
    functional: "Cookies fonctionnels",
    functionalDesc: "Essentiels au bon fonctionnement du site.",
    analytics: "Cookies analytiques",
    analyticsDesc: "Nous aident \u00e0 comprendre comment les visiteurs interagissent avec le site.",
    marketing: "Cookies marketing",
    marketingDesc: "Utilis\u00e9s pour diffuser des publicit\u00e9s personnalis\u00e9es.",
    saveSettings: "Enregistrer les param\u00e8tres",
  },
};

export default fr;
